import React from "react";
import classes from "./SectionHeader.module.css";
import SearchInput from "../SearchInput";
import { mergeClass } from "../../../resources/utils/helper";
import Button from "../../atoms/Button";

export default function SectionHeader({
  title,
  showButton,
  showSearch,
  label,
  variant,
  leftIcon,
  btnClass,
  onClick,
  search,
  setSearch = () => {},
}) {
  return (
    <div className={mergeClass(" pb-4 ", classes.mainDiv)}>
      <p className={mergeClass("fs-30 fw-700 ", classes.title)}>{title}</p>

      <div className={classes.rightDiv}>
        {showSearch && (
          <SearchInput
            placeholder="Search"
            inputStyle={{
              paddingLeft: "70px",
            }}
            customStyle={{
              border: "1px solid var(--dark-gray)",
              borderRadius: "10px",
            }}
            // leftIconStyle={{ paddingLeft: "10px" }}
            setValue={setSearch}
            value={search}
          />
        )}
        {showButton && (
          <Button
            onClick={onClick}
            label={label}
            variant={variant}
            leftIcon={leftIcon}
            className={btnClass}
            customStyle={{ padding: "15px 25px" }}
          />
        )}
      </div>
    </div>
  );
}
